module.exports = __webpack_public_path__ + "static/media/my-account-bg.2a53b52c.jpg";